import { Observable, forkJoin } from 'rxjs';
import { Credenciales } from '../../../core/entities/credenciales.model';
import { Notices } from 'src/app/core/entities/notices.model';
import { Injectable } from '@angular/core';
import { AuthenticationService } from '../../../core/auth/authentication.service';
import { RepositoryService } from 'src/app/core/repositories/repository.service';
import { map, catchError } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { DESHAB_INTERNA, PETICIONES, WARNING_ACCES_INTERNA } from 'src/app/core/utils/constants';
import * as _ from 'lodash';


@Injectable()
export class InternalAccesoService {

  user: Credenciales = new Credenciales();
  notices: Notices = new Notices();
  noticeswarning: Notices = new Notices();

  constructor(private authService: AuthenticationService,
              private repositoryService: RepositoryService) { }

  public initView(): Observable<any>{
    return forkJoin([
      this.repositoryService.findByCode(PETICIONES.notices.findByCode, DESHAB_INTERNA),
      this.repositoryService.findByCode(PETICIONES.notices.findByCode, WARNING_ACCES_INTERNA)])
        .pipe(map(dataGroup => {
          this.notices = _.cloneDeep(dataGroup[0]);
          this.noticeswarning = _.cloneDeep(dataGroup[1]);
        return true;
      }),catchError((error: any) => {
        console.log(error);           
        throw error;
      }));
  }

  public doLogin(): Observable<any> {
    // Aquí se hace el login y se devuelve el resultado: true: OK, false: Credenciales erróneas, null: Error
    return this.authService.doLogin(this.user)
    .pipe(map(data => {
      console.log(data);
      return data;
    }),
    map(data => {
      this.authService.saveUser(this.user.username ?? '', data.accessToken, data.refreshToken, data.allrols, data.idEmpresa, data.tokenWs);
      return true;
    }),
    catchError((error: any) => {
      console.log(error);
      return throwError(error);
    }));
  }

}
